import {
  binCountSessionIdFormat,
  locationIdFormat,
  productIdFormat,
  storageLocationIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const createBinCountSession = {
  name: "createBinCountSession" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    storageLocationId: storageLocationIdFormat.schema.optional(),
    binCount: z.number().int().min(1).max(999).optional(),
    productId: productIdFormat.schema.optional(),
  }),
  output: z.object({ binCountSessionId: binCountSessionIdFormat.schema }),
};
